import { ViewConfig } from "@lib/views";
import { TaskGroupActionsCell } from "./cells/TaskGroupActionsCell";
import { TaskGroupCountCell } from "./cells/TaskGroupCountCell";
import { TaskGroupNameCell } from "./cells/TaskGroupNameCell";
import { TaskGroupUpdatedCell } from "./cells/TaskGroupUpdatedCell";

export enum WorkspaceTaskGroupColumn {
    NAME = "name",
    TASKS = "tasks",
    UPDATED = "updated",
    ACTIONS = "actions",
}

export interface WorkspaceTaskGroupRow {
    id: string;
    name: string;
    taskCount: number | null;
    updatedAt: Date;
    organizationId: string | null;
    systemKey: string | null;
}

export const workspaceTaskGroupsViewConfig: ViewConfig<
    WorkspaceTaskGroupRow,
    WorkspaceTaskGroupColumn,
    never
> = {
    columns: {
        [WorkspaceTaskGroupColumn.NAME]: {
            accessorKey: "name",
            name: "Name",
            header: "Name",
            cell: TaskGroupNameCell,
            minSize: 220,
            maxSize: 1200,
        },
        [WorkspaceTaskGroupColumn.TASKS]: {
            accessorKey: "taskCount",
            name: "Tasks",
            header: "Tasks",
            cell: TaskGroupCountCell,
            minSize: 100,
            maxSize: 120,
        },
        [WorkspaceTaskGroupColumn.UPDATED]: {
            accessorKey: "updatedAt",
            name: "Updated",
            header: "Updated",
            cell: TaskGroupUpdatedCell,
            minSize: 140,
            maxSize: 180,
        },
        [WorkspaceTaskGroupColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: TaskGroupActionsCell,
            minSize: 64,
            maxSize: 64,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
